<template>
  <div class="leading-none">
    <div class="space-x-0.5 leading-none">
      <template v-if="showCurrentMaterial">
        <span class="text-white ui-text-sm underline underline-offset-1">
          {{ currentMaterial?.currentTranslation?.title }}
        </span>
      </template>
      <template v-for="(item, index) in cutMaterials" v-else :key="item.id">
        <UiLazyImg
          v-if="showImages"
          class="size-4 rounded-full overflow-hidden transition-all duration-300 ease-out"
          :src="
            getImageByPosition(item.medias, 'list')?.file?.url ||
            '/images/no-image.webp'
          "
          :alt="
            getImageByPosition(item.medias, 'list')?.file?.alt ||
            item.currentTranslation?.title
          "
        />
        <p
          class="inline-block space-x-0.5 text-white ui-text-xs cursor-pointer"
          @click="setCurrentMaterial(item)"
        >
          <span
            :class="[
              'underline-offset-1',
              { underline: item.id === currentMaterial?.id },
            ]"
          >
            {{ item.currentTranslation.title }}
          </span>
          <span v-if="index !== data.materials.length - 1">/</span>
        </p>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CatalogData, Material, MaterialCategory } from "ecom-types";
import { CardProduct } from "~/composables";
import { propertiesGroupSlugs } from "~/configs";

interface ProductMaterialsWithCategories extends MaterialCategory {
  materials: Material[];
}

const emit = defineEmits<{
  (e: "filter", data: { slug: string; item: Material }): void;
}>();

const props = withDefaults(
  defineProps<{
    data: ProductMaterialsWithCategories;
    product?: CardProduct | CatalogData | null;
    showImages?: boolean;
    showCurrentMaterial?: boolean;
  }>(),
  {
    showImages: false,
    product: null,
    showCurrentMaterial: false,
  },
);

// const plan = ref(props.data?.materials?.[0]?.sku);

const currentMaterial = ref<Material | undefined>(
  props.data.materials?.find((el) =>
    props.product?.default_config?.materials?.some((i) => i === el.id)
  )
);

function setCurrentMaterial(material: Material) {
  const includeInSku = props.product?.material_categories_in_sku?.includes(
    material.material_category_id
  );
  const isMetal = props.data.slug === propertiesGroupSlugs.metal;
  if (includeInSku && isMetal) {
    currentMaterial.value = material;
    emit("filter", {
      slug: propertiesGroupSlugs.metal,
      item: material,
    });
  }
}

const cutMaterials = computed<Material[]>(() => {
  return props.data?.materials || [];
});
</script>
